import { render } from "./SpeechRequestItemGhost.vue?vue&type=template&id=dece0f10&scoped=true"
import script from "./SpeechRequestItemGhost.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./SpeechRequestItemGhost.vue?vue&type=script&charset=utf-8&lang=js"

import "./SpeechRequestItemGhost.vue?vue&type=style&index=0&id=dece0f10&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dece0f10"]])

export default __exports__